<div class="relative mb-10">
  <input
    (blur)="onSearchBarBlurred()"
    (focus)="onSearchBarFocused()"
    [ngModel]="searchTerm"
    (ngModelChange)="onSearchTermChanged($event)"
    type="search"
    [placeholder]="isSearchBarFocused ? '' : placeholder"
    [class.pb-3]="isSearchBarFocused || searchTerm !== ''"
    [class.pt-5]="isSearchBarFocused || searchTerm !== ''"
    [ngClass]="{
      'bg-neutralBg': !isSearchBarFocused && isFilledAndBlurred,
      'bg-white': isSearchBarFocused
    }"
    [class.bg-[#F7F7F8]]="!isSearchBarFocused && isFilledAndBlurred"
    class="w-full p-4 text-black outline-none focus:border-primary border border-[#A0A2A7] rounded-md focus:caret-primary placeholder-[#6C6E75]"
    data-cs-capture
  />
  <label
    [class.hidden]="!isSearchBarFocused && !isFilledAndBlurred"
    class="absolute top-0 mt-1 left-0 ml-4 text-[#6C6E75] text-xs"
    >{{ placeholder }}</label
  >
  <img
    src="../../../../../assets/images/svg/magnifier.svg"
    class="mr-2 w-6 h-6"
    alt="magnifier"
    class="absolute top-1/2 -translate-y-1/2 right-4"
  />
</div>
